<template>
 <section v-if="hasPermissions(['Assignment-Project-Template Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                Select the rooms you want to add to a project, click Add them to a project, select the project and click Save.
            </p>
        </div>

        <div class="bar-container">
             <div class="bar-container__search-bar">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-on:input="debounceInput($event.target.value)">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Assignment-Project-Template Write'])" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" style="margin-bottom: 0px;"  v-html="'Add them to a project'" @click="open_project_modal()"/>
            </div>
        </div>

        

        <RoomTaskAdvancedSearchVue
            class="mt-5"
            ref="advanced_search"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api_pagination"
            :table_headers="table_headers"
            :filter_options="filter_options"
            :default_filters="default_filters"
            :rooms_to_parent="rooms_to_parent"
            :search="search"
            @passInitialData="fill_data($event)"
        />

        <ProjectModal
            :title="'Projects Modal'"
            :projects="projects"
            :breadcrumb="breadcrumb"
            :rest_api="'projects-rooms'"
            :selected_rooms="selected_rooms"
            @reset_checkboxes="reset_checkboxes"
            :rooms_to_parent="rooms_to_parent"
            @returnedRoomsToParent="returnedRoomsToParent($event)"
        />
        <WaitingModal/>

    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Methods          from    './methods'
import FormResources    from    './form_resources'
import Resources        from    './resources'
import ProjectModal     from    './ProjectModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import RoomTaskAdvancedSearchVue from '@/components/BuildingComponent/Rooms/RoomTaskAdvancedSearch/RoomTaskAdvancedSearch.vue'
import _ from 'lodash'
import { Notyf }        from    'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'ProjectScheduledRooms',

    components: {
        Breadcrumb,
        WaitingModal,
        RoomTaskAdvancedSearchVue,
        ProjectModal,
        UnauthorizedComponent
    },

    mixins:[
        Methods,
    ],

    data() {
        return {
            notyf,
            child_href:             '',
            user:                   this.get_user(),
            title_page:             'Scheduled Rooms',
            rest_api:               `projects-scheduled-rooms`,
            rest_api_pagination:    `projects-rooms_pagination`,
            rest_api_general:       `general_functions`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            field:                  FormResources.fields,
            shift_options:          FormResources.shift_options,
            inactive_rooms_options: Resources.inactive_rooms_options,
            next_scheduled_options: Resources.next_scheduled_options,
            add_btn:                'Add Project',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            projects:               [],
            scheduled_rooms:        [],
            default_filters:    Resources.default_filters,
            filter_options:     Resources.filter_options,

            array_options:      {
                building_id:        [],
                area_id:            [],
                level_id:           [],
                project_task_id:    [],
            },

            form_data:          FormResources.form_data,
            form_format:        FormResources.form_format,
            form_backup:        {...FormResources.form_data},

            current_date:       '',
            inactive_status:    '',
            next_scheduled:     0,
            rooms_to_parent: {}
        }
    },

    methods:
    {
        debounceInput:  _.debounce(function (e)  {
            this.search = e
        },800),
        
        open_project_modal()
        {
            if(!this.$refs.advanced_search.returnedRoomsToParent().checked_items?.length)
            {
                notyf.error('No rooms selected')
                return false
            }

            window.$('#static_project_modal').modal('show')
        },

        fill_data(data)
        {
            this.projects = data.projects
            this.array_options = {
                building_id:    data.buildings,
                level_id:       '',
                area_id:        '',
                task_id:        data.tasks,
                room_type_id:   data.room_types,
                floor_id:       data.floors,
                cost_center_id: data.cost_centers,
                frequency_id:   data.frequencies,
                group_id:       data.groups
            }
        },

        reset_checkboxes()
        {
             this.scheduled_rooms.map(item => item.checked = false)
        },
    },

    computed: {

        selected_rooms ()
        {
            return this.scheduled_rooms.filter(item => item.checked)
        },

    },

    async mounted()
    {

        console.log(this.dateDecrement(30).original_format_date, 'menos 30 dias')

        console.log(this.dateDecrement(60).original_format_date, 'menos 60 dias')

        console.log(this.dateDecrement(90).original_format_date, 'menos 90 dias')
    }
}
</script>